module.exports = __webpack_public_path__ + "fonts/0d39f25.woff";